import React, { Component } from 'react';
import classNames from 'classnames';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import style from './Checkbox.scss';

export default class Checkbox extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    children: PropTypes.node.isRequired,
    checked: PropTypes.bool,
    value: PropTypes.string,
  };

  static defaultProps = {
    type: 'checkbox',
  };

  static contextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    formik: PropTypes.object,
  };

  renderCheckbox({ children, className, ...props }) {
    return (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      <label className={classNames(style.checkbox, className)}>
        <input {...props} className={style.checkbox__input} id={props.id || props.name} />
        <div className={style.checkbox__label}>{children}</div>
      </label>
    );
  }

  render() {
    const { formik } = this.context;
    if (!formik) {
      return this.renderCheckbox(this.props);
    }
    return (
      <Field name={this.props.name}>
        {({ field, form }) => {
          let { checked } = this.props;
          if (typeof checked === 'undefined') {
            const value = form.values && form.values[this.props.name];
            checked = this.props.type === 'checkbox' ? value === true : value === this.props.value;
          }
          return this.renderCheckbox({ ...field, ...this.props, checked });
        }}
      </Field>
    );
  }
}
